<template>
  <div class="overview-section-wrapper">
    <div class="section">
      <div class="section-number">
        {{ numberOfItem }}
      </div>
      <div class="section-title">Items</div>
    </div>
    <div class="section">
      <div class="section-number">
        {{ numberOfOwner }}
      </div>
      <div class="section-title">Owners</div>
    </div>
    <div class="section">
      <div class="section-number">
        {{ numberOfTrade }}
      </div>
      <div class="section-title">Traded</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    numberOfItem: {
      type: [Number, String],
      default: 0
    },
    numberOfOwner: {
      type: [Number, String],
      default: 0
    },
    numberOfTrade: {
      type: [Number, String],
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/config/_variables';

.overview-section-wrapper {
  background-color: #f6f8fc;
  border-radius: 8px;
  display: flex;
  width: min-content;
  margin: auto;

  .section {
    width: 220px;
    padding: 15px 0;
    text-align: center;
    border-right: 1px solid #f3f5fa;
    &:last-child {
      border-right: none;
    }
    .section-number {
      font-family: Inter-ExtraBold;
      font-size: 26px;
      color: #203a54;
    }
    .section-title {
      font-family: Inter-Regular;
      font-size: 18px;
      color: #828c9f;
    }
  }
}
@media screen and (max-width: $breakpoint-mobile) {
  .overview-section-wrapper {
    width: 100%;
    flex-wrap: wrap;
  }
}
</style>
